'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/7/5.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ServiceInfo, _Component);

  function ServiceInfo() {
    (0, _classCallCheck3.default)(this, ServiceInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceInfo).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(ServiceInfo, [{
    key: 'render',
    value: function render() {
      var styles = require('./ServiceInfo.scss');
      var _props = this.props;
      var index = _props.index;
      var service = _props.service;

      var rightClassName = '';
      if ((index + 1) % 3 === 0) {
        rightClassName = styles.mr0 + ' ' + styles.w420;
      }
      return _react2.default.createElement(
        'li',
        { className: styles.sel_box_Li + ' ' + rightClassName },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/service/' + service.serviceType + '/' + service.id, target: '_blank' },
          _react2.default.createElement(
            'dl',
            null,
            _react2.default.createElement(
              'dd',
              null,
              _react2.default.createElement('img', { className: styles.box_a_biao, src: service.serviceTypeImg, alt: '' }),
              _react2.default.createElement('img', { src: service.img, alt: '' })
            ),
            _react2.default.createElement(
              'dt',
              { style: { position: 'relative', height: '107px' } },
              _react2.default.createElement(
                'div',
                { className: styles.hudd },
                _react2.default.createElement(
                  'div',
                  { className: styles.float },
                  _react2.default.createElement(
                    'div',
                    { className: styles.hudd_shu },
                    service.title
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.hudd_img },
                  _react2.default.createElement('img', {
                    src: service.icon, alt: '' })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ServiceInfo;
}(_react.Component), _class.propTypes = {
  index: _react.PropTypes.number.isRequired,
  service: _react.PropTypes.object.isRequired
}, _temp);
exports.default = ServiceInfo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceInfo/ServiceInfo.js
 ** module id = 1416
 ** module chunks = 0
 **/